import {
    Link, useParams,
} from "react-router-dom";
import {useEffect, useState} from "react";
import "flag-icons/css/flag-icons.css";
import {Posts} from "./Posts";
import {SlideShow} from "./Slideshow";
export function Post() {
    const { postId } = useParams();
    const [content, setContent] = useState('');
    const [slideshowImages, setSlideshowImages] = useState(null);
    const [slideshowsImages, setSlideshowsImages] = useState([]);

    useEffect(() => {
        // Fetch the HTML file based on the postId
        fetch(`/posts/${postId}.html`)
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.text();
            })
            .then((html) => {
                setContent(html);
            })
            .catch((error) => {
                console.error('There was a problem with the fetch operation:', error);
                setContent(`<h1>404 Stránka sa nenašla</h1><Link to="/">Späť domov</Link>`);
            });
    }, [postId]);

    useEffect(() => {
        for (const category in Posts) {
            if(Array.isArray(Posts[category])) {
                for (let i = 0; i < Posts[category].length; i++) {
                    if(Posts[category][i] && Posts[category][i].id === postId) {
                        if(Posts[category][i].slideshow) {
                            setSlideshowImages(Posts[category][i].slideshow);
                        }
                        if(Posts[category][i].slideshows) {
                            setSlideshowsImages(Posts[category][i].slideshows);
                        }
                        return;
                    }
                }
            }
        }
    }, [])


    return <div className="content-wrapper">
        <div className={"article-wrapper"} dangerouslySetInnerHTML={{__html: content}}/>
        {
            slideshowImages && <SlideShow images={slideshowImages}/>
        }
        {
            slideshowsImages && slideshowsImages.map(slideshow => <SlideShow images={slideshow}/>)
        }
    </div>
}